export default {
  EM_ANALISE: 'EM_ANALISE',
  AGUARDANDO_EMISSAO_OFICIO_CERTIDAO_NEGATIVA:
    'AGUARDANDO_EMISSAO_OFICIO_CERTIDAO_NEGATIVA',
  OFICIO_CERTIDAO_NEGATIVA_EM_ANDAMENTO:
    'OFICIO_CERTIDAO_NEGATIVA_EM_ANDAMENTO',
  EMISSAO_MATRICULA_MINUTA_EM_ANDAMENTO:
    'EMISSAO_MATRICULA_MINUTA_EM_ANDAMENTO',
  AGUARDANDO_EMISSAO_MATRICULA_MINUTA: 'AGUARDANDO_EMISSAO_MATRICULA_MINUTA',
  AGUARDANDO_ENVIO_CARTORIO_CERTIDAO_NEGATIVA:
    'AGUARDANDO_ENVIO_CARTORIO_CERTIDAO_NEGATIVA',
  AGUARDANDO_ASSINATURA_PORTARIA: 'AGUARDANDO_ASSINATURA_PORTARIA',
  AGUARDANDO_NUMERACAO_PORTARIA: 'AGUARDANDO_NUMERACAO_PORTARIA',
  AGUARDANDO_ENCAMINHAR_DIARIO_OFICIAL: 'AGUARDANDO_ENCAMINHAR_DIARIO_OFICIAL',
  AGUARDANDO_PUBLICACAO_DIARIO_OFICIAL: 'AGUARDANDO_PUBLICACAO_DIARIO_OFICIAL',
  AGUARDANDO_ENVIO_CARTORIO_MATRICULA: 'AGUARDANDO_ENVIO_CARTORIO_MATRICULA',
  AGUARDANDO_CONFIRMACAO_RECEBIMENTO_MATRICULA:
    'AGUARDANDO_CONFIRMACAO_RECEBIMENTO_MATRICULA',
  PUBLICACAO_DIARIO_OFICIAL_EM_ANDAMENTO:
    'PUBLICACAO_DIARIO_OFICIAL_EM_ANDAMENTO',
  AGUARDANDO_VALIDACAO: 'AGUARDANDO_VALIDACAO',
  AGUARDANDO_VALIDACAO_OFICIO_MATRICULA:
    'AGUARDANDO_VALIDACAO_OFICIO_MATRICULA',
  AGUARDANDO_ASSINATURA:
    'AGUARDANDO_ASSINATURA',
  AGUARDANDO_ASSINATURA_CN: 'AGUARDANDO_ASSINATURA_CN',
  AGUARDANDO_ASSINATURA_OFICIO_MATRICULA:
    'AGUARDANDO_ASSINATURA_OFICIO_MATRICULA',
  AGUARDANDO_ENVIO_OFICIO_MATRICULA_CARTORIO:
    'AGUARDANDO_ENVIO_OFICIO_MATRICULA_CARTORIO',
  AGUARDANDO_ARQUIVAMENTO: 'AGUARDANDO_ARQUIVAMENTO',
  EM_ARQUIVAMENTO: 'EM_ARQUIVAMENTO',
  AGUARDANDO_RETIFICACAO_CADASTRO: 'AGUARDANDO_RETIFICACAO_CADASTRO',
  AGUARDANDO_VALIDACAO_CADASTRO: 'AGUARDANDO_VALIDACAO_CADASTRO',
  AGUARDANDO_VALIDACAO_RETIFICACAO: 'AGUARDANDO_VALIDACAO_RETIFICACAO',
  AGUARDANDO_PARECER: 'AGUARDANDO_PARECER',
  EM_EMISSAO_OFICIO_CN: 'EM_EMISSAO_OFICIO_CN',
  AGUARDANDO_EMISSAO_OFICIO_CN: 'AGUARDANDO_EMISSAO_OFICIO_CN',
  AGUARDANDO_RETORNO_CARTORIO: 'AGUARDANDO_RETORNO_CARTORIO',
  AGUARDANDO_EMISSAO_PORTARIA: 'AGUARDANDO_EMISSAO_PORTARIA',
  AGUARDANDO_EMISSAO_MINUTA: 'AGUARDANDO_EMISSAO_MINUTA',
  EM_EMISSAO_MINUTA: 'EM_EMISSAO_MINUTA.PRESIDENTE.CPAT',
  AGUARDANDO_PARECER_MATRICULA: 'AGUARDANDO_PARECER_MATRICULA',
  AGUARDANDO_ENVIO_DIARIO_OFICIAL: 'AGUARDANDO_ENVIO_DIARIO_OFICIAL',
  AGUARDANDO_MINUTA_MATRICULA: 'AGUARDANDO_MINUTA_MATRICULA',
  AGUARDANDO_ASSINATURA_MATRICULA: 'AGUARDANDO_ASSINATURA_MATRICULA',
  AGUARDANDO_EMISSAO_MATRICULA: 'AGUARDANDO_EMISSAO_MATRICULA',
  VALIDACAO_EM_ANDAMENTO: 'VALIDACAO_EM_ANDAMENTO',
  VALIDACAO_RETIFICACAO_EM_ANDAMENTO: 'VALIDACAO_RETIFICACAO_EM_ANDAMENTO',
  REVISAO_EM_ANDAMENTO: 'REVISAO_EM_ANDAMENTO',
  AGUARDANDO_ENVIO_MATRICULA: 'AGUARDANDO_ENVIO_MATRICULA',
  AGUARDANDO_ANALISE: 'AGUARDANDO_ANALISE',
  AGUARDANDO_GERACAO_DOCUMENTOS: 'AGUARDANDO_GERACAO_DOCUMENTOS'
}



// WEBPACK FOOTER //
// ./src/constants/statusProcessoArrecadacao.js